import React from 'react';
import useAuthGateState from '../hooks/useAuthGateState';
import useToken from './useToken';
import { AUTH_TIMEOUT_MS } from './authConstants';

// Login state only; unlike useAuthReady it never touches the portal token.
export const useAuthStatus = () => {
  const state = useAuthGateState();
  const candidateLoggedIn = state.candidateLogin.loggedIn;
  const portalLoggedIn = state.portalAuth.loggedIn;
  const checkedAuth = state.candidateLogin.checkedAuth;
  const [timedOut, setTimedOut] = React.useState(false);

  React.useEffect(() => {
    const timeout = setTimeout(() => setTimedOut(true), AUTH_TIMEOUT_MS);
    return () => clearTimeout(timeout);
  }, []);

  const isLoggedIn = portalLoggedIn || candidateLoggedIn;

  const loading = !checkedAuth && !timedOut;

  return { loading, isLoggedIn };
};

const useAuthReady = () => {
  const status = useAuthStatus();
  const token = useToken();

  return { ...status, token };
};

export default useAuthReady;
